import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-16 bg-white" data-id="element-50">
      <div className="container mx-auto px-4" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h2 className="font-serif text-3xl font-bold text-kgi-blue-900 mb-4" data-id="element-53">
            Contact Us
          </h2>
          <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-54">
            Reach out to our team of professional investigators for a
            confidential consultation. Mention our website to receive 10% off
            your first service!
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-55">
          <div className="bg-white rounded shadow-sm p-8 border-t-4 border-kgi-red" data-id="element-56">
            <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-6" data-id="element-57">
              Get In Touch
            </h3>
            <div className="space-y-6" data-id="element-58">
              <div className="flex items-start" data-id="element-59">
                <MapPinIcon className="h-6 w-6 text-kgi-red mr-3 mt-0.5" data-id="element-60" />
                <div data-id="element-61">
                  <h4 className="font-medium text-gray-900" data-id="element-62">Address</h4>
                  <p className="text-gray-600" data-id="element-63">
                    34914 Forest Street
                    <br data-id="element-64" />
                    Wayne, MI 48184
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-65">
                <PhoneIcon className="h-6 w-6 text-kgi-red mr-3 mt-0.5" data-id="element-66" />
                <div data-id="element-67">
                  <h4 className="font-medium text-gray-900" data-id="element-68">Office Line</h4>
                  <p className="text-gray-600" data-id="element-69">
                    <a href="tel:3138446179" className="hover:text-kgi-red" data-id="element-70">
                      313-844-6179
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-71">
                <PhoneIcon className="h-6 w-6 text-kgi-red mr-3 mt-0.5" data-id="element-72" />
                <div data-id="element-73">
                  <h4 className="font-medium text-gray-900" data-id="element-74">
                    Emergency Contact for Cases
                  </h4>
                  <p className="text-gray-600" data-id="element-75">
                    <a href="tel:2489142861" className="hover:text-kgi-red" data-id="element-76">
                      248-914-2861
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-77">
                <MailIcon className="h-6 w-6 text-kgi-red mr-3 mt-0.5" data-id="element-78" />
                <div data-id="element-79">
                  <h4 className="font-medium text-gray-900" data-id="element-80">Email</h4>
                  <p className="text-gray-600" data-id="element-81">
                    <a href="mailto:info@koda-is.com" className="hover:text-kgi-red" data-id="element-82">
                      info@koda-is.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-83">
                <ClockIcon className="h-6 w-6 text-kgi-red mr-3 mt-0.5" data-id="element-84" />
                <div data-id="element-85">
                  <h4 className="font-medium text-gray-900" data-id="element-86">Hours</h4>
                  <p className="text-gray-600" data-id="element-87">
                    Monday - Friday: 9:00 AM - 5:00 PM
                    <br data-id="element-88" />
                    24/7 Emergency Services Available
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded shadow-sm p-8 border-t-4 border-kgi-blue" data-id="element-89">
            <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-6" data-id="element-90">
              Send Us a Message
            </h3>
            <form data-id="element-91">
              <div className="mb-4" data-id="element-92">
                <label htmlFor="name" className="block text-gray-700 mb-2" data-id="element-93">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-2 border border-mw-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-kgi-blue focus:border-transparent" placeholder="Your name" data-id="element-94" />
              </div>
              <div className="mb-4" data-id="element-95">
                <label htmlFor="email" className="block text-gray-700 mb-2" data-id="element-96">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-2 border border-mw-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-kgi-blue focus:border-transparent" placeholder="Your email address" data-id="element-97" />
              </div>
              <div className="mb-4" data-id="element-98">
                <label htmlFor="phone" className="block text-gray-700 mb-2" data-id="element-99">
                  Phone
                </label>
                <input type="tel" id="phone" className="w-full px-4 py-2 border border-mw-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-kgi-blue focus:border-transparent" placeholder="Your phone number" data-id="element-100" />
              </div>
              <div className="mb-4" data-id="element-101">
                <label htmlFor="service" className="block text-gray-700 mb-2" data-id="element-102">
                  Service Needed
                </label>
                <select id="service" className="w-full px-4 py-2 border border-mw-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-kgi-blue focus:border-transparent" data-id="element-103">
                  <option value="" data-id="element-104">Select a service</option>
                  <option value="electronic-surveillance" data-id="element-105">
                    Electronic Surveillance
                  </option>
                  <option value="missing-persons" data-id="element-106">Missing Persons</option>
                  <option value="workers-compensation" data-id="element-107">
                    Workers Compensation & Insurance Fraud
                  </option>
                  <option value="domestic-cases" data-id="element-108">Domestic Cases</option>
                  <option value="child-welfare" data-id="element-109">
                    Child Welfare and Custody
                  </option>
                  <option value="trial-preparation" data-id="element-110">Trial Preparation</option>
                  <option value="background-investigations" data-id="element-111">
                    Background Investigations
                  </option>
                  <option value="process-serving" data-id="element-112">Process Serving</option>
                  <option value="security" data-id="element-113">Security</option>
                  <option value="gps-devices" data-id="element-114">
                    Global Positioning Devices
                  </option>
                </select>
              </div>
              <div className="mb-6" data-id="element-115">
                <label htmlFor="message" className="block text-gray-700 mb-2" data-id="element-116">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-mw-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-kgi-blue focus:border-transparent" placeholder="Tell us about your needs" data-id="element-117"></textarea>
              </div>
              <button type="submit" className="w-full bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-3 px-6 rounded transition duration-300" data-id="element-118">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
};